import { RouterProvider } from "@tanstack/react-router"
import { useAuthInit } from "./hooks/useAuthInit"
import { router } from "./routes/router"
import { Toaster } from "./components/ui/toaster"

export const App = () => {
  useAuthInit()

  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  )
}
